/**
 * @copyright 2021 @ DigiNet
 * @author ANHTAI
 * @create 2021/12/10 08:08
 * @update 2021/12/10 08:08
 */

import moment from "moment";
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as templateDropdownActions from "../../actions/template-dropdown-actions";
import * as w18f1061Actions from "../../actions/w18F1061-actions";
import Config from '../../config/index';
import { Avatar, Col, Button, ButtonIcon, Popover, Typography } from "diginet-core-ui/components";
import { makeStyles, useTheme } from "diginet-core-ui/theme";
import Icons from "diginet-core-ui/icons";
import { Collapse, TextInput } from 'diginet-core-ui/components';

const useStyles = makeStyles(({ colors }) => ({
    btnActionItem: {
        textAlign: 'left',
        '&:hover': {
            backgroundColor: `${colors.hover} !important`
        }
    }
}));
class W18F1061_ItemComment extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            idEdit: "",
            showComment: false,
            dataComment: [],
        }
        this.btnCommentRef = null;
        this.btnMoreAnchor = null;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { CodeID = "" } = this.props;
        if (prevProps.CodeID !== CodeID) this.loadComment();
    }

    loadComment = () => {
        const { CodeID } = this.props;
        if (Config.isEmpty(CodeID)) return;
        const params = {
            FormID: "W18F1061",
            CodeID
        };
        this.props.w18f1061Actions.getListComment(params, (error, data) => {
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                if (!Config.isEmpty(data)) this.setState({ dataComment: data });
            }
        });
    };

    onEnterPress = (e) => {
        if (e?.keyCode === 13 && !e?.shiftKey) {
            e.preventDefault();
            this.addComment(e?.target?.value || '');
        }
    };

    addComment = (txt = "") => {
        const { formID: FormAction = "", FormID, CodeID } = this.props;
        const { dataComment } = this.state;
        const params = {
            FormID,
            FormAction,
            CodeID,
            Message: txt
        };
        this.props.w18f1061Actions.addComment(params, (err, data) => {
            if (err) {
                Config.popupCore.show('ERROR', err);
                return false;
            } else if (data) {
                if (!Config.isEmpty(data)) {
                    const dataTemp = [...dataComment, data];
                    this.setState({ dataComment: dataTemp });
                    document.querySelector('#inputComment').value = "";
                }
            }
        });
    };

    editComment = (item = {}, text = "") => {
        this.setState({ idEdit: "" });
        const { formID: FormAction = "", FormID, CodeID } = this.props;
        const { dataComment } = this.state;
        const params = {
            FormID,
            FormAction,
            CodeID,
            CommentID: item?.CommentID || '',
            Message: text
        };
        this.props.w18f1061Actions.editComment(params, (error, data) => {
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                if (!Config.isEmpty(data)) {
                    let dataTemp = [...dataComment];
                    dataTemp.forEach((i, idx) => {
                        if (i.CommentID === data[0].id) {
                            dataTemp[idx].updatedAt = data[0].updatedAt;
                            dataTemp[idx].Message = data[0].Message;
                            this.setState({ dataComment: dataTemp });
                        }
                    });
                }
            }
        });
    };

    removeComment = (item = {}) => {
        const { dataComment } = this.state;
        this.props.w18f1061Actions.removeComment({ CommentID: item?.CommentID || '' }, (error, data) => {
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                if (!Config.isEmpty(data)) {
                    let dataTemp = [...dataComment];
                    dataTemp.forEach((i, idx) => {
                        if (i.CommentID === data.id) {
                            dataTemp.splice(idx, 1);
                            this.setState({ dataComment: dataTemp });
                        }
                    });
                }
            }
        });
    };

    render() {
        const { showComment, idEdit, dataComment } = this.state;

        return (
            <>
                <div className={"display_row align-center cursor-pointer mgb3x"}
                    onClick={() => {
                        this.setState({ showComment: !showComment });
                    }}
                >
                    <Icons
                        color={"info"}
                        name={"ArrowDownFilled"}
                        className={"mgr3x"}
                        width={18} height={18}
                        style={{ transition: 'transform .5s', transform: `${showComment ? 'rotate(177deg)' : ''}` }}
                    />
                    <Typography type={"h4"} color={"info"}>{Config.lang("Thao_luan")} ({dataComment.length})</Typography>
                </div>
                <Collapse open={showComment}>
                    {!Config.isEmpty(dataComment) && dataComment.map((item, idx) => {
                        return <ItemComment
                            idEdit={idEdit}
                            onChangeIdEdit={(id) => {
                                this.setState({ idEdit: id });
                            }}
                            data={item}
                            key={idx}
                            createdAt={item.createdAt}
                            editComment={(txtEdit) => this.editComment(item, txtEdit)}
                            addComment={(txtEdit) => this.addComment(txtEdit)}
                            removeComment={() => this.removeComment(item)}
                        />
                    })}
                    <Col md={12} sm={12} xs={12} lg={8} className={"display_row"}>
                        <Avatar width={34} height={34} className={"mgr3x"} src={Config.profile.URL} />
                        <TextInput
                            inputProps={{ id: 'inputComment' }}
                            viewType={'outlined'}
                            onKeyDown={this.onEnterPress}
                            placeholder={Config.lang("Viet_binh_luan")} />
                    </Col>
                </Collapse>
            </>
        )
    }
}

class ItemComment extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            isEdit: false,
            isTooltip: false,
        }
    }

    cancelEdit = () => {
        const { onChangeIdEdit } = this.props;
        this.setState({ isEdit: false });
        if (onChangeIdEdit) onChangeIdEdit(null);
    };

    showEditComment = () => {
        const { onChangeIdEdit, data } = this.props;
        this.setState({ isEdit: true });
        this.hideDropdownMenu();
        if (onChangeIdEdit) onChangeIdEdit(data?.CommentID || '');
    };

    hideDropdownMenu = () => {
        this.setState({ isTooltip: false }, () => {
            document.removeEventListener("click", this.hideDropdownMenu);
        });
    };

    editComment = (value) => {
        const { editComment } = this.props;
        this.setState({ isEdit: true });
        if (editComment) editComment(value);
    };

    removeComment = () => {
        const { removeComment } = this.props;
        Config.popup.show("YES_NO", Config.lang("Ban_co_chac_chan_muon_xoa_du_lieu_nay"), () => {
            if (removeComment) removeComment();
        });
        this.setState({ isTooltip: false });
    };

    onEnterPress = (e) => {
        if (e?.keyCode === 13 && !e?.shiftKey) {
            e.preventDefault();
            this.addComment(e?.target?.value || '');
        }
    };

    renderBtnCommentAction = () => {
        const classes = useStyles();
        const { isTooltip } = this.state;
        return (
            <Popover
                arrow
                ref={ref => this.btnCommentRef = ref}
                open={isTooltip}
                anchorOrigin={{
                    vertical: 'center',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'center',
                    horizontal: 'left',
                }}
                anchor={this.btnMoreAnchor}
                onClose={() => this.setState({ isTooltip: false })}
            >
                <Button
                    className={classes.btnActionItem}
                    size={"small"}
                    color={"primary"}
                    viewType={"text"}
                    startIcon={"Edit"}
                    label={Config.lang("Sua")}
                    onClick={this.showEditComment}
                />
                <Button
                    className={classes.btnActionItem}
                    size={"small"}
                    color={"primary"}
                    viewType={"text"}
                    startIcon={"Delete"}
                    label={Config.lang("Xoa")}
                    onClick={this.removeComment}
                />
            </Popover>
        )
    };

    render() {
        const { data, idEdit } = this.props;
        const { isEdit, isTooltip } = this.state;
        const { colors } = useTheme();
        if (!data.SalesPersonNameU && !data.URL) {
            const user = Config.getUser({ UserID: data.UserID });
            if (user) {
                data.URL = user ? user.URL : null;
                data.SalesPersonNameU = user ? user.SalesPersonNameU : null;
            }
        }
        return (
            <div className={"display_row mgb4x"}>
                <Avatar width={40} height={40} className={"mgr3x"} src={data?.URL} />
                {(!isEdit || idEdit !== data?.CommentID || '') &&
                    <div className={"display_row align-center"}>
                        <div className={"pdt3x pdr5x pdb3x pdl5x"}
                            style={{
                                position: 'relative',
                                background: colors.fill.headerbar,
                                borderRadius: 10
                            }}>
                            <div className={"display_row align-center mgb1x"}>
                                <Typography className={"mgr1x"} color={"primary"}>{data?.SalesPersonNameU || ''}</Typography>
                                <Typography type={"p3"} color={"secondary"}>{moment(data?.createdAt || '').format("DD/MM/YYYY[,]HH:mm:ss")}</Typography>
                            </div>
                            <Typography type={"p2"}>{data?.Message || ''}</Typography>
                        </div>
                        {Config.profile.UserID === data?.UserID &&
                            <div className={"mgl1x"}>
                                <ButtonIcon circular
                                    ref={ref => this.btnMoreAnchor = ref}
                                    name={"MoreHoriz"}
                                    viewType={"ghost"}
                                    onClick={() => {
                                        this.setState({ isTooltip: !isTooltip }, () => {
                                            document.addEventListener("click", this.hideDropdownMenu);
                                        });
                                    }} />
                                {isTooltip && this.renderBtnCommentAction()}
                            </div>
                        }
                    </div>
                }
                {isEdit && (data?.CommentID || '') === idEdit &&
                    <div style={{ position: 'relative', width: '100%' }}>
                        <TextInput
                            viewType={'outlined'}
                            value={data?.Message || ''}
                            onKeyDown={this.onEnterPress}
                            placeholder={Config.lang("Viet_binh_luan")}
                        />
                    </div>
                }
            </div>
        )
    }
}

W18F1061_ItemComment.propTypes = {
    FormID: PropTypes.string,
    CodeID: PropTypes.string
};

export default connect(state => ({
    cboSalePerson: state.templateDropdown.cboSalePerson,
}), (dispatch) => ({
    w18f1061Actions: bindActionCreators(w18f1061Actions, dispatch),
    templateDropdownActions: bindActionCreators(templateDropdownActions, dispatch),
}), null, { withRef: true }
)(W18F1061_ItemComment);